/* Ajout panier AJAX depuis la vue liste B2B (délégation sur #product-grid).
   Après ajout : bouton "✓ Ajouté", bulle panier rafraîchie via Section Rendering API. */
(function () {
  function refreshCartBubble() {
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + '?sections=cart-icon-bubble' : '/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-icon-bubble'];
        if (!html) return;
        var current = document.getElementById('cart-icon-bubble');
        if (!current) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#cart-icon-bubble') || tmp.firstElementChild;
        if (fresh) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-row-extras__add');
    if (!btn) return;
    var buy = btn.closest('.card-row-extras__buy');
    if (!buy) return;
    var qtyInput = buy.querySelector('.card-row-extras__qty');
    var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
    if (qty < 1) qty = 1;
    var variantId = parseInt(buy.dataset.variantId, 10);
    if (!variantId) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        btn.disabled = false;
        if (res.ok) {
          btn.textContent = '✓ Ajouté';
          btn.classList.add('is-added');
          refreshCartBubble();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () {
            btn.textContent = original;
            btn.classList.remove('is-added');
          }, 2000);
        } else {
          btn.textContent = original;
          alert(res.data.description || 'Erreur lors de l’ajout au panier.');
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  });
})();
